/**
 * Owner: Masa Bayu
 * File: auth-email.ts
 * Date:Time: 2026-09-27 15:18
 * Description: Normalize email before the qxp-hub auth API call.
 */

export function normalizeAuthEmail(raw: string): string {
  return raw.trim().toLowerCase();
}
